"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var startDownloadNextRequiredMediafile_1 = __importDefault(require("../actions/mediafiles/startDownloadNextRequiredMediafile"));
var startNextMediafileCleanup_1 = __importDefault(require("../actions/mediafiles/startNextMediafileCleanup"));
var _kernel_container_1 = __importDefault(require("../../container"));
function downloadMediafileSchedule(dispatch, getState) {
    var state = getState();
    var isConnected = state.global.isConnected;
    var settings = _kernel_container_1.default.get("SETTINGS");
    var downloadingEnabled = settings.getSetting("TRACK_DOWNLOADING_ENABLED", false);
    if (isConnected && downloadingEnabled) {
        dispatch((0, startDownloadNextRequiredMediafile_1.default)());
        dispatch((0, startNextMediafileCleanup_1.default)());
    }
}
exports.default = downloadMediafileSchedule;
//# sourceMappingURL=downloadMediafiles.js.map